import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { DxSelectBoxComponent } from 'devextreme-angular';
import { SelectBoxSearchMode } from '../../../base/src/abcSelectBox/abcSelectBox';

@Component({
    selector: '',
    template: `<div class="selectBoxClass">
    <dx-select-box
      #dxSelectBox
      [id]="id"
      [items]="items"
      [showClearButton]="showClearButton"
      [(value)]="value"
      [valueExpr]="valueExpr"
      [showClearButton]="showClearButton"
      [disabled]="disabled"
      [dataSource]="dataSource"
      [label]="placeholder"
      [placeholder]="''"
      [stylingMode]="stylingMode"
      [displayExpr]="displayExpr"
      [readOnly]="readOnly"
      [height]="height"
      [width]="width"
      [visible]="visible"
      [showDropDownButton]="showDropDownButton"
      [showSelectionControls]="showSelectionControls"
      [showClearButton]="showClearButton"
      [validationStatus]="validationStatus"
      [hoverStateEnabled]="hoverStateEnabled"
      [rtlEnabled]="rtlEnabled"
        [acceptCustomValue]="acceptCustomValue"
      [searchMode]="searchMode"
      [searchExpr]="searchExpr"
      [searchTimeout]="searchTimeout"
      [searchEnabled]="searchEnabled"
      [ngClass]="class"
      [noDataText]="''"
      fieldTemplate="{{ fieldTemplate }}"
      (onCustomItemCreating)="customItemCreating($event)"
      (onValueChanged)="valueChanged($event)"
      labelMode="floating"
    >
      <div *dxTemplate="let data of 'field'">
        <div class="custom-item" If="data && data.CountryCode">
          <dx-text-box [value]="data && data.CountryCode"></dx-text-box>
        </div>
      </div>
    </dx-select-box>
  </div>`,
    styleUrls: ['./devExSelectBox.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class DevExSelectBoxComponent implements OnInit {
  @Input() id: string;
  @Input() items: string[];
  @Input() displayExpr: string;
  @Input() hideSelectedItems: boolean;
  @Input() multiline: boolean;
  @Input() acceptCustomValue: boolean;
  @Input() disabled: boolean;
  @Input() dataSource: any[];
  @Input() placeholder: string;
  @Input() showClearButton: boolean;
  @Input() readOnly: boolean;
  @Input() valueExpr: string;
  @Input() stylingMode: string;
  @Input() hoverStateEnabled: boolean;
  @Input() height: string;
  @Input() width: string;
  @Input() visible: boolean = true;
  @Input() validationStatus: string;
  @Input() showDropDownButton: boolean;
  @Input() showSelectionControls: boolean;
  @Input() rtlEnabled: boolean;
  @Input() searchMode: SelectBoxSearchMode;
  @Input() searchExpr: string[];
  @Input() searchTimeout: number;
  @Input() searchEnabled: boolean;
  @Input() class: string;
  @Input() specificTemplate: boolean;
  @Input()
  get value(): any {
    return this._value;
  }
  set value(val: any) {
    this._value = val;
    this.valueChange.emit(val);
  }
  @Output() valueChange = new EventEmitter();
  @Output()
  onValueChanged = new EventEmitter();
  @Output() onSelectedItem = new EventEmitter();
  @Output() onCustomItemCreating = new EventEmitter();
  @ViewChild('dxSelectBox', { static: true }) dxSelectBox: DxSelectBoxComponent;
  public fieldTemplate: string;
  private _value: any;

  constructor() {}

  ngOnInit() {
    this.fieldTemplate = this.specificTemplate == true ? 'field' : '';
  }
  valueChanged(e) {
    this.onValueChanged.emit(e);
    this.onSelectedItem.emit(this.dxSelectBox.selectedItem);
  }
  customItemCreating(e){
    this.onCustomItemCreating.emit(e);
  }
  updateDataSource(dataSource) {
    this.dataSource = dataSource;
  }
  updatePlaceholder(placeholder) {
    this.placeholder = placeholder;
  }
}
